export const E2E = {
  page: {
    homepage: {
      lo: 'loHomepage',
      li: 'liHomepage',
    },
    compilationDetails: 'compilationDetails',
    blockDetails: 'blockDetails',
    bodi: 'bodiPage',
    programs: 'programs',
    fitness: 'fitness',
    allWorkouts: 'allWorkouts',
    allFitnessPrograms: 'allFitnessPrograms',
    programDetails: 'programDetails',
    favorites: 'favoritesPage',
    search: 'searchPage',
    fitnessQuiz: 'fitnessQuiz',
  },
  section: {
    hero: 'hero',
    editorialModule: 'editorialModule',
    footer: 'footer',
    bodiModule: 'bodiModule',
    coachModule: 'coachModule',
    statsModule: 'statsModule',
    metricDashboard: 'metricDashboard',
    limitedEditionBadges: 'limitedEditionBadges',
    workoutStats: 'workoutStats',
    recentlyEarnedBadges: 'recentlyEarnedBadges',
    inProgressBadges: 'inProgressBadges',
    featuredProgramsRail: 'featuredProgramsRail',
    quizResultsRail: 'quizResultsRail',
    mostPopularProgramsRail: 'mostPopularProgramsRail',
    myProgramsRail: 'myProgramsRail',
    myPurchasesRail: 'myPurchasesRail',
    jbiModule: 'jbiModule',
    welcomeBanner: 'welcomeBanner',
    blog: 'blog',
    commerceModule: 'commerceModule',
    exploreRail: 'exploreRail',
    bodiPreviewsRail: 'bodiPreviewsRail',
    favoritesRail: 'favoritesRail',
    bodiBlocksRail: 'bodiBlocksRail',
    superBlocksRail: 'superBlocksRail',
    healthEsteemRail: 'healthEsteemRail',
    categoriesRail: 'categoriesRail',
    trainersRail: 'trainersRail',
    lessonsRail: 'lessonsRail',
    nutritionCollection: 'nutritionCollection',
    socialFeedModule: 'socialFeedModule',
    tabSwitcher: 'tabSwitcher',
    contentOverview: 'contentOverview',
    contentOverviewTrainer: 'contentOverviewTrainer',
    trainerBio: 'trainerBio',
    recommendationsRail: 'recommendationsRail',
    workoutsRail: 'workoutsRail',
    recentlyWatchedProgramsRail: 'recentlyWatchedProgramsRail',
    ambassadorSubscriptionsRail: 'ambassadorSubscriptionsRail',
    tenMinuteProgramsRail: 'tenMinuteProgramsRail',
    recipesRail: 'recipesRail',
    results: 'results',
    filters: 'filters',
    sortBy: 'sortBy',
  },
  component: {
    card: 'card',
    container: 'container',
    data: 'data',
    grid: 'grid',
    title: 'title',
    icon: 'icon',
    image: 'image',
    text: 'text',
    violator: 'violator',
    button: 'button',
    wrapper: 'wrapper',
    slider: 'slider',
    modal: 'modal',
    backgroundImage: 'backgroundImage',
    tab: 'tab',
    description: 'description',
    logo: 'logo',
    subtitle: 'subtitle',
    link: 'link',
    footer: 'footer',
    totalCount: 'totalCount',
  },
} as const
